module.exports = __webpack_public_path__ + "img/asx_power.3587710b.jpg";